/**
 * Maps the JWT `userType` claim values (which come back as the .NET role-name strings:
 * "Administrator", "Adjuster", "Customer", "TowProvider", "Driver") to the all-caps
 * enum tokens used throughout the React client (ADMIN, ADJUSTER, CUSTOMER, TOWPROVIDER, DRIVER).
 *
 * Established as a duplicated literal across catalog list and detail pages from slices 22 / 24
 * forward; extracted here in slice 55 so every consumer reads the same source-of-truth.
 */
export const JWT_USER_TYPE_TO_ENUM: Record<string, string> = {
  Administrator: 'ADMIN',
  Adjuster: 'ADJUSTER',
  Customer: 'CUSTOMER',
  TowProvider: 'TOWPROVIDER',
  Driver: 'DRIVER',
};

/**
 * Returns the all-caps role-enum token for a JWT userType claim value, or the
 * original input untouched when it doesn't match a known role (defensive — keeps
 * the behavior consumers had before extraction).
 */
export function normalizeUserType(jwtUserType: string): string {
  return JWT_USER_TYPE_TO_ENUM[jwtUserType] ?? jwtUserType;
}
